"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SiteHeading = _interopRequireDefault(require("./header/SiteHeading"));
var _LoginLink = _interopRequireDefault(require("./header/LoginLink"));
var _MenuCards = _interopRequireDefault(require("./header/MenuCards"));
var _MobileHamburger = _interopRequireDefault(require("./header/MobileHamburger"));
var _WelcomeMessage = _interopRequireDefault(require("./header/WelcomeMessage"));
var _MenuLinks = _interopRequireDefault(require("./header/MenuLinks"));
var _MultiSiteDropDown = _interopRequireDefault(require("./header/multi-site/MultiSiteDropDown"));
var _ApplicationContext = require("../api/ApplicationContext");
var _SecurityContextHolder = require("../api/SecurityContextHolder");
var _UserBar = _interopRequireDefault(require("./header/UserBar"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const isPopup = () => window.opener && window.opener !== window;
class Header extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      isActive: false,
      isAuthenticated: false
    };
    this.toggleActive = this.toggleActive.bind(this);
  }
  componentDidMount() {
    const {
      history,
      logoutPath
    } = this.props;
    const {
      isAuthenticated
    } = this.state;
    this.unlisten = history.listen(() => {
      if (isAuthenticated !== _SecurityContextHolder.SecurityContextHolder.isAuthenticated()) {
        this.setState({
          isAuthenticated: _SecurityContextHolder.SecurityContextHolder.isAuthenticated()
        });
      }
      if (window.location.pathname === logoutPath) {
        this.setState({
          isAuthenticated: false
        });
      }
      this.toggleActive(false);
    });
  }
  componentWillUnmount() {
    this.unlisten();
  }
  toggleActive(isActive) {
    this.setState({
      isActive
    });
  }
  cssPathName() {
    const {
      location
    } = this.props;
    return location?.pathname ? location.pathname.replace(/\W/g, '-') : '';
  }
  render() {
    const {
      loginPath,
      logoutPath,
      profilePath,
      contactUs,
      loginLink,
      logoutLink,
      site,
      headerLinks,
      welcome,
      images,
      logo,
      logoAlt,
      logoSize,
      isBrandingColorWheel,
      slimView
    } = this.props;
    const {
      isActive,
      isAuthenticated
    } = this.state;
    const superUser = _SecurityContextHolder.SecurityContextHolder.getCurrentContext()?.impersonator;
    const externalClassName = !_SecurityContextHolder.SecurityContextHolder.isAuthenticated() ? 'external' : '';
    const externalShowTitleClassName = (_ApplicationContext.ApplicationContext.getCoBrand() || _ApplicationContext.ApplicationContext.getHeaderShowTitleExternal()) && !_SecurityContextHolder.SecurityContextHolder.isAuthenticated() ? 'external-show-title' : '';
    const activeClass = isActive ? 'is-active' : 'is-not-active';
    const notMegaClass = _SecurityContextHolder.SecurityContextHolder.isAuthenticated() && _ApplicationContext.ApplicationContext.isMegaMenu() || !_SecurityContextHolder.SecurityContextHolder.isAuthenticated() && _ApplicationContext.ApplicationContext.isPublicMegaMenu() ? '' : 'is-not-mega';
    const menuStyle = _ApplicationContext.ApplicationContext.getMenuStyle() || 'normal';
    return /*#__PURE__*/_react.default.createElement("nav", {
      id: "navigation",
      className: `${menuStyle} ${notMegaClass} ${externalClassName} ${externalShowTitleClassName} page-${this.cssPathName()}`
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: `navbar-main ${activeClass} ${notMegaClass}`
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "navbar-brand"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "navbar-item"
    }, /*#__PURE__*/_react.default.createElement(_SiteHeading.default, {
      siteTitle: _ApplicationContext.ApplicationContext.getSiteTitle(),
      siteSubTitle: _ApplicationContext.ApplicationContext.getSiteSubTitle(),
      coBrand: _ApplicationContext.ApplicationContext.getCoBrand(),
      logo: typeof logo !== 'undefined' ? logo : _ApplicationContext.ApplicationContext.getLogo(),
      logoAlt: typeof logoAlt !== 'undefined' ? logoAlt : _ApplicationContext.ApplicationContext.getLogoAlt(),
      logoSize: typeof logoSize !== 'undefined' ? logoSize : _ApplicationContext.ApplicationContext.getLogoSize(),
      isBrandingColorWheel: typeof isBrandingColorWheel !== 'undefined' ? isBrandingColorWheel : _ApplicationContext.ApplicationContext.isBrandingColorWheel()
    }), /*#__PURE__*/_react.default.createElement(_MenuCards.default, {
      key: `MenuCards${isAuthenticated}`,
      images: images
    })), !isPopup() && /*#__PURE__*/_react.default.createElement(_MobileHamburger.default, {
      toggleActive: this.toggleActive,
      isActive: isActive
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: `navbar-menu ${activeClass}`
    }, /*#__PURE__*/_react.default.createElement(_WelcomeMessage.default, {
      isDesktop: true,
      key: `WelcomeMessage1${isAuthenticated}`,
      customWelcome: welcome
    }), !isPopup() && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "navbar-start"
    }, /*#__PURE__*/_react.default.createElement(_MultiSiteDropDown.default, {
      toggleActive: this.toggleActive,
      isActive: isActive,
      key: `MultiSiteDropDown${isAuthenticated}`,
      className: "is-fullwidth is-large"
    }), /*#__PURE__*/_react.default.createElement(_MenuLinks.default, {
      toggleActive: this.toggleActive,
      isActive: isActive,
      key: `MenuLinks${isAuthenticated}`,
      site: site
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "navbar-end"
    }, slimView && (loginLink || /*#__PURE__*/_react.default.createElement(_LoginLink.default, {
      loginPath: loginPath,
      key: `LoginLink${isAuthenticated}`
    })))))), /*#__PURE__*/_react.default.createElement(_UserBar.default, {
      activeClass: activeClass,
      isAuthenticated: isAuthenticated,
      welcome: welcome,
      isActive: isActive,
      toggleActive: this.toggleActive,
      superUser: superUser,
      headerLinks: headerLinks,
      contactUs: contactUs,
      slimView: slimView,
      loginLink: loginLink,
      loginPath: loginPath,
      logoutLink: logoutLink,
      logoutPath: logoutPath,
      profilePath: profilePath
    }), menuStyle === 'tab' && /*#__PURE__*/_react.default.createElement("div", {
      className: "navbar navbar-user-ribbon"
    }, "\xA0"), /*#__PURE__*/_react.default.createElement("div", {
      id: "modal-root"
    }));
  }
}
var _default = exports.default = (0, _reactRouterDom.withRouter)(Header);
Header.propTypes = {
  images: _propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.element, _propTypes.default.object])),
  logo: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  logoAlt: _propTypes.default.string,
  logoSize: _propTypes.default.string,
  isBrandingColorWheel: _propTypes.default.string,
  loginPath: _propTypes.default.string,
  logoutPath: _propTypes.default.string,
  profilePath: _propTypes.default.string,
  history: _propTypes.default.shape({
    listen: _propTypes.default.func.isRequired
  }),
  location: _propTypes.default.shape({
    pathname: _propTypes.default.string
  }),
  contactUs: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  loginLink: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  logoutLink: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  welcome: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  site: _propTypes.default.shape({
    public: _propTypes.default.shape({
      isMegaMenu: _propTypes.default.bool
    })
  }),
  headerLinks: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node, _propTypes.default.element, _propTypes.default.object]),
  slimView: _propTypes.default.bool
};
Header.defaultProps = {
  loginPath: _ApplicationContext.ApplicationContext.getLoginPath(),
  logoutPath: _ApplicationContext.ApplicationContext.getLogoutPath(),
  profilePath: _ApplicationContext.ApplicationContext.getProfilePath(),
  slimView: true
};
//# sourceMappingURL=Header.js.map